import { meshBasicMaterial } from '@/config';
import { materialUpdater } from '@/littleWedding/canvasMaterialsManager';
import { throttle } from '@/utils/throttle';
import { useConfigStore } from '@/store/config.store';
import { ref, watch, nextTick, type ComputedRef } from 'vue';
import { MeshBasicMaterial } from 'three';
import { storeToRefs } from 'pinia';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITextField } from '@/typescript/interfaces/ITextField';
import type { WFabricWorld } from '@/littleWedding/WFabricWorld';

export function useMaterialUpdater(fabricFields: ComputedRef<(IImageField | ITextField)[]>, fabricWorld: WFabricWorld) {
    const customMaterial = ref<MeshBasicMaterial>(meshBasicMaterial);
    const { isCup } = storeToRefs(useConfigStore());

    const throttleMaterialUpdater = throttle(
        () => {
            materialUpdater({
                customMaterial,
                fabricWorld,
                isPreview: true,
            });
        },
        150,
        {
            throttleTimer: false,
        },
    );
    function updateMaterial(force = false) {
        if (!isCup.value && !force) {
            return;
        }
        throttleMaterialUpdater();
    }

    watch(fabricFields, () => {
        // This function is trigger before image 2D is update.
        // Delay it change this behavior
        nextTick(() => {
            updateMaterial();
        });
    });

    return { updateMaterial };
}
